import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ArticleManager from '../components/admin/ArticleManager';
import AdManager from '../components/admin/AdManager';
import VideoManager from '../components/admin/VideoManager';
import FeaturedArticlesManager from '../components/admin/FeaturedArticlesManager';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('articles');
  const [username, setUsername] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    const storedUsername = localStorage.getItem('admin_username');
    
    if (!token) {
      navigate('/admin');
      return;
    }

    setUsername(storedUsername);
    verifyAuth(token);
  }, [navigate]);

  const verifyAuth = async (token) => {
    try {
      await axios.get(`${API}/auth/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (err) {
      console.error('Auth verification failed:', err);
      handleLogout();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_username');
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="bg-zinc-900 border-b border-zinc-800">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-light tracking-wide">ADMIN DASHBOARD</h1>
            <p className="text-sm text-gray-500 mt-1">Welcome, {username}</p>
          </div>
          <div className="flex items-center gap-4">
            <a href="/" className="text-sm text-gray-400 hover:text-white transition-colors">View Site</a>
            <button
              onClick={handleLogout}
              className="px-4 py-2 border border-zinc-700 text-sm hover:bg-zinc-800 transition-colors"
            >
              LOGOUT
            </button>
          </div>
        </div>
      </header>

      {/* Tabs */}
      <div className="border-b border-zinc-800">
        <div className="max-w-7xl mx-auto px-6">
          <nav className="flex gap-8">
            <button
              onClick={() => setActiveTab('articles')}
              className={`py-4 text-sm font-medium tracking-wider border-b-2 transition-colors ${
                activeTab === 'articles'
                  ? 'border-white text-white'
                  : 'border-transparent text-gray-500 hover:text-white'
              }`}
            >
              ARTICLES
            </button>
            <button
              onClick={() => setActiveTab('videos')}
              className={`py-4 text-sm font-medium tracking-wider border-b-2 transition-colors ${
                activeTab === 'videos'
                  ? 'border-white text-white'
                  : 'border-transparent text-gray-500 hover:text-white'
              }`}
            >
              VIDEOS
            </button>
            <button
              onClick={() => setActiveTab('featured')}
              className={`py-4 text-sm font-medium tracking-wider border-b-2 transition-colors ${
                activeTab === 'featured'
                  ? 'border-white text-white'
                  : 'border-transparent text-gray-500 hover:text-white'
              }`}
            >
              FEATURED
            </button>
            <button
              onClick={() => setActiveTab('ads')}
              className={`py-4 text-sm font-medium tracking-wider border-b-2 transition-colors ${
                activeTab === 'ads'
                  ? 'border-white text-white'
                  : 'border-transparent text-gray-500 hover:text-white'
              }`}
            >
              ADS
            </button>
            <button
              onClick={() => navigate('/admin/invoice')}
              className="py-4 text-sm font-medium tracking-wider text-[#00FF7F] hover:text-white transition-colors flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              CREATE INVOICE
            </button>
          </nav>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        {activeTab === 'articles' && <ArticleManager />}
        {activeTab === 'videos' && <VideoManager />}
        {activeTab === 'featured' && <FeaturedArticlesManager />}
        {activeTab === 'ads' && <AdManager />}
      </div>
    </div>
  );
}

export default AdminDashboard;
